export const generateArrayOfNumbers = (start: number, length: number) => Array.from({ length }, (_, i) => i + start);

export const isNumeric = (n: unknown): n is number => !isNaN(parseFloat(String(n))) && isFinite(Number(n));
